import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 16a4 4 0 1 0 -4 -4v1","key":"svg-1"}],["path",{"d":"M6 12l2 2l2 -2","key":"svg-2"}]]

const IconCreativeCommonsSa = createReactComponent('outline', 'creative-commons-sa', 'CreativeCommonsSa', __iconNode);

export default IconCreativeCommonsSa;